import { createFileRoute } from "@tanstack/react-router";
import CatalogCardPage from "@/site/pages/catalog-card";

/**
 * Canonical card URL: `/card/view/:cardId/:slug` (BDAY-23 · PRD 01 §5.12).
 * The number (`card_no`) is the identity; the slug is decorative — document
 * requests with a stale/missing slug get a server-side 301, and client-side
 * navigations self-heal in the page (replace-navigate to the current slug).
 * The slugless `/card/view/:cardId` route stays as the redirect entry shape.
 */

/** Category context (old `ccid`) the card was opened from — drives breadcrumb + suggestions. */
type CardViewSearch = { ccid?: string };

export const Route = createFileRoute("/card/view/$cardId_/$slug")({
  component: CatalogCardPage,
  validateSearch: (search: Record<string, unknown>): CardViewSearch => ({
    ccid: typeof search.ccid === "string" && search.ccid ? search.ccid : undefined,
  }),
});
